// Navigation.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import HamburgerMenu from "../HamburgerMenu";
import Auth from "../../utils/auth";
import { URLS } from "../../config/urls";
import { QUERY_SYSTEM_SETTING } from "../../utils/graphql/systemSettings/queries";
import { BsSun, BsMoon } from "react-icons/bs";
import "./App.css";

// TODO: Re-implement if needed later
// const NavLinks = ({ routes }) => {
//   return (
//     <div className="right">
//       {routes.map((route) => {
//         // Link route
//         if (route.path) {
//           return (
//             <Link
//               key={route.label}
//               className="nav-bar-links"
//               to={route.path}
//             >
//               {route.label}
//             </Link>
//           );
//         }

//         // Action route (like Logout)
//         return (
//           <button
//             key={route.label}
//             className="nav-bar-links"
//             onClick={route.onClick}
//             style={{
//               background: "none",
//               border: "none",
//               padding: 0,
//               cursor: "pointer",
//             }}
//           >
//             {route.label}
//           </button>
//         );
//       })}
//     </div>
//   );
// };

const Navigation = ({ me, loggedIn, isDark, toggleColorMode }) => {
  const logout = () => Auth.logout();
  const isAdmin = me?.admin === true;
  const { data: googleIntegrationSettingData } = useQuery(QUERY_SYSTEM_SETTING, {
    variables: { key: "googleWorkspaceIntegrationEnabled" },
  });
  const googleWorkspaceIntegrationEnabled =
    String(googleIntegrationSettingData?.systemSetting?.value ?? "true").toLowerCase() !== "false";

  const LOGIN_URL = googleWorkspaceIntegrationEnabled ? URLS.googleAuth : "/login";

  const routes = React.useMemo(() => {
    if (!loggedIn) return [];

    const base = [
      { path: "/", label: "Jobs" },
      { path: "/job-report", label: "Master Sub List" },
      { path: "/my-calendar", label: "Calendar" },
      { path: "/profile", label: "Profile" },
    ];

    if (isAdmin) {
      base.push({ path: "/admin", label: "Admin" });
    }

    base.push({
      label: isDark ? "Switch to light mode" : "Switch to dark mode",
      onClick: toggleColorMode,
    });

    base.push({ label: "Logout", onClick: logout });

    return base;
  }, [loggedIn, isAdmin, isDark, toggleColorMode]);

  return (
    <nav className="right nav-bar-links-container">
      {loggedIn ? (
        <>
          <Link className="nav-bar-links nav-desktop-links" to="/">
            Jobs
          </Link>

          <Link className="nav-bar-links nav-desktop-links" to="/job-report">
            Master Sub List
          </Link>

          <button
            className="dark-toggle-btn nav-desktop-links"
            onClick={toggleColorMode}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDark ? <BsSun size={16} /> : <BsMoon size={16} />}
          </button>

          <HamburgerMenu routes={routes} />
        </>
      ) : (
        <>
          <button
            className="dark-toggle-btn"
            onClick={toggleColorMode}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDark ? <BsSun size={16} /> : <BsMoon size={16} />}
          </button>
          <Link className="nav-bar-links" to={LOGIN_URL} target="_self">
            {googleWorkspaceIntegrationEnabled ? "Login" : "Google Login Disabled"}
          </Link>
        </>
      )}
    </nav>
  );
};

export default React.memo(Navigation);